const GET_STATS = 'GET_STATS'
const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS'
const GET_STATS_FAILURE = 'GET_STATS_FAILURE'

export {
  GET_STATS,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE
}



// WEBPACK FOOTER //
// ./src/reducks/stats/types.js